<template>
  <FilterFoundation
    data-testid="instrument-filter"
    :label="label"
    :active="active"
    :disabled="disabled"
    v-on="$listeners"
  >
    <template #right-slot>
      <div class="instrument-filter__icon">
        <BaseIcon
          :icon="iconName"
          width="20"
          height="20"
          colors="currentColor"
        />
      </div>
    </template>
  </FilterFoundation>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { BaseIcon, FilterFoundation } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    BaseIcon,
    FilterFoundation
  }
})
export default class InstrumentFilterSelect extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isOpen!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly active!: boolean;

  @Prop({ type: String, default: 'Todos os ativos' })
  readonly label!: string;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  get iconName() {
    return this.isOpen ? 'ic_chevron_up' : 'ic_chevron_down';
  }
}
</script>

<style lang="less" scoped>
.instrument-filter {
  &__icon {
    line-height: 0;
  }
}
</style>
